import { useCallback, useState } from "react"

import { useAppSelector } from "store/hooks"
import { UITypes } from "types"
import SubscriptionPrivilege from "types/enums/SubscriptionPrivilege"

import { getDateRangeFromOption } from "utils/dateUtils"
import hasSubscriptionAccess from "utils/hasSubscriptionAccess"
import { ChartUnavailableOverlay } from "components/common/ChartUnavailableOverlay"
import { WidgetAlertStatuses } from "components/widgets/WidgetAlertStatuses"
import { dateSelectOptions } from "pages/vendor/Dashboard/constants"

import { DashboardWidgetSection } from "../components/Dashboard/Dashboard"
import { WidgetMonitoringAlerts } from "./WidgetMonitoringAlerts"

type DateRange = [string, string]

export const AlertsSection = () => {
  const userProfile = useAppSelector(state => state.user.userProfile)
  const hasAlertsAccess = userProfile ? hasSubscriptionAccess(userProfile, SubscriptionPrivilege.Alerts) : false
  const unsupported = !hasAlertsAccess

  const [dateRange, setDateRange] = useState<DateRange>(() =>
    getDateRangeFromOption(String(dateSelectOptions[0].value)),
  )

  const handleSelectDateRange = useCallback((newDateRange: DateRange) => {
    setDateRange(newDateRange)
  }, [])

  return (
    <DashboardWidgetSection
      title="Alerts"
      withDateRangePicker={hasAlertsAccess}
      dateRange={dateRange}
      onSelectDateRange={handleSelectDateRange}
      defaultTimeRange={dateSelectOptions[0] as UITypes.Option}
    >
      <ChartUnavailableOverlay isUnsupported={unsupported} privilege={SubscriptionPrivilege.Alerts}>
        <WidgetMonitoringAlerts dateRange={dateRange} unsupported={unsupported} />
      </ChartUnavailableOverlay>
      <ChartUnavailableOverlay isUnsupported={unsupported} privilege={SubscriptionPrivilege.Alerts}>
        <WidgetAlertStatuses dateRange={dateRange} unsupported={unsupported} updateIndex={0} />
      </ChartUnavailableOverlay>
    </DashboardWidgetSection>
  )
}
